"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("../Api"));
const Auth_1 = __importDefault(require("./Auth"));
const Category_1 = __importDefault(require("./Category"));
const Menu_1 = __importDefault(require("./Menu"));
const Merchant_1 = __importDefault(require("./Merchant"));
const MerchantPrinter_1 = __importDefault(require("./MerchantPrinter"));
const Order_1 = __importDefault(require("./Order"));
class OrderappMerchantApi extends Api_1.default {
    constructor(baseUrlGo, baseUrlNode) {
        super(baseUrlGo, baseUrlNode);
        this.auth = new Auth_1.default(this);
        this.category = new Category_1.default(this);
        this.menu = new Menu_1.default(this);
        this.merchant = new Merchant_1.default(this);
        this.merchantPrinter = new MerchantPrinter_1.default(this);
        this.order = new Order_1.default(this);
    }
}
exports.default = OrderappMerchantApi;
//# sourceMappingURL=index.js.map